import 'popper.js';
import 'bootstrap';
import 'owl.carousel';

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.scmaBehavior = {
    attach: function (context, settings) {
      //console.log('Hello World');

    }
  };

  Drupal.behaviors.homePageCarousels = {
    attach: function (context, settings) {
      var home_features = $('.home-features.owl-carousel');
      home_features.owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        items: 1,
        dots: true,
        autoplay: false,
        autoplayHoverPause: true,
        autoplayTimeout: 6000,
        autoplaySpeed: 1000,
        navSpeed: 1000,
      });

      //$('.featured-collection .views-row:first-child').attr('data-merge', '2');
      $('.featured-collection .views-row:first-child').addClass('big');
      $('.featured-collection .views-row:nth-child(2)').addClass('med');
      var featured_collection = $('.featured-collection .owl-carousel');
      featured_collection.owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText: [
          '<i class="fas fa-arrow-left"><span>left</span></i>',
          '<i class="fas fa-arrow-right"><span>right</span></i>'
        ],
        items: 3,
        responsiveClass: true,
        dots: false,
        autoplay: false,
        itemClass: 'owl-item',
        responsive: {
          0:{
            items:2,
            nav:true,
            loop:true
          },
          1120:{
            items:3,
          }
        }
      });

      featured_collection.on('changed.owl.carousel', function(event) {
        var index = event.item.index + 1;
        var index2 = index + 1;
        $('.featured-collection .owl-item .views-row').removeClass('big med');
        $('.featured-collection .owl-item:nth-child('+index+') .views-row').addClass('big');
        $('.featured-collection .owl-item:nth-child('+index2+') .views-row').addClass('med');
        //$('.featured-collection .views-row').attr('data-merge', '1');
        //$('.featured-collection .owl-item:nth-child('+index+') .views-row').attr('data-merge', '2');
        //featured_collection.trigger('refresh.owl.carousel');
        //console.log(index);
      });
    }
  };

  Drupal.behaviors.visitHours = {
    attach: function (context, settings) {
      // get current day
      var weekdays = new Array('sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday')
      var dateobj = new Date();
      var day = dateobj.getDay();
      //var today = new Intl.DateTimeFormat('en-US', { weekday: 'long'}).format(day);
      //var today2 = today.toLowerCase();
      // add active class to current day of openhours
      var today_hours = $('.openhours-day .'+weekdays[day]+' .hours').text();
      $('.openhours-day').html(today_hours);
      //console.log(weekdays[day]);
      $('.visit-hours .field.image .field__item:first-child').addClass('active');
      $('.visit-hours .item').hover(function () {
        $('.visit-hours .field.image .field__item').removeClass('active');
        if ($(this).hasClass('item-1')) {
          $('.visit-hours .field.image .field__item:first-child').addClass('active');
        }
        else if ($(this).hasClass('item-2')) {
          $('.visit-hours .field.image .field__item:nth-child(2)').addClass('active');
        }
        else if ($(this).hasClass('item-3')) {
          $('.visit-hours .field.image .field__item:nth-child(3)').addClass('active');
        }
      });

      //$('.today-hours')

    }
  };

  Drupal.behaviors.collectionHighlights = {
    attach: function (context, settings) {
      jQuery('.new-acquisitions.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText: [
          '<i class="fas fa-arrow-left"></i>',
          '<i class="fas fa-arrow-right"></i>'
        ],
        items: 3,
        dots: false,
        autoplay: false,
        itemClass: 'owl-item',
        responsiveClass: true,
        responsive: {
          0:{
            items:1,
            nav:true,
            loop:false
          },
          768: {
            items:2,
          },
          992:{
            items:3,
          }
        }
      });
    }
  }

  Drupal.behaviors.calendarBehavior = {
    attach: function (context, settings) {
      // program highlights carousel
      jQuery('.program-highlights.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText: [
          '<i class="fas fa-arrow-left"></i>',
          '<i class="fas fa-arrow-right"></i>'
        ],
        items: 1,
        dots: false,
        autoplay: false,
      });

      // program events list filter toggles
      jQuery('.program-events-list form .form-item.js-form-type-checkbox').each(function() {
        if (jQuery(this).find('input').is(':checked')) {
          jQuery(this).addClass('active');
        }
      });
      $('.program-events-list form .form-item.js-form-type-checkbox').click(function() {
        if ($(this).find('input').is(':checked')) {
          $(this).addClass('active');
        }
        else {
          $(this).removeClass('active');
        }
      });
      $('fieldset[data-drupal-selector="edit-field-event-date-value-1-wrapper"]', context).each(function() {
        if ($(this).find('input').val()) {
          $(this).addClass('active');
        }
      });
      $('fieldset[data-drupal-selector="edit-field-event-date-value-1-wrapper"] .label', context).click(function() {
        if ($(this).parent().hasClass('active')) {
          $(this).parent().removeClass('active');
        }
        else {
          $(this).parent().addClass('active');
        }
      })
    }
  }

  Drupal.behaviors.exhibitionArtworkCarousel = {
    attach: function (context, settings) {
      jQuery('.node.exhibition .entity-reference.owl-carousel, .node.article .entity-reference.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        navText: [
          '<i class="fas fa-arrow-left"></i>',
          '<i class="fas fa-arrow-right"></i>'
        ],
        items: 1,
        dots: false,
        autoplay: false,
      });
    }
  };

  Drupal.behaviors.exhibitsLinks = {
    attach: function (context, settings) {
      $('.block--current-upcoming-past-exhibits-links .body a', context).each(function() {
        // for each link
        // get link path and match against url path
        // if match then add 'active' class
        var link = $(this).attr('href');
        var url_path = window.location.pathname;
        console.log(url_path);
        if (link === url_path) {
          $(this).addClass('active');
        }
      });
    }
  };

  Drupal.behaviors.actionButtons = {
    attach: function (context, settings) {
      // get vertical position of action buttons on page load
      // set watch for onscroll event
      // once scroll => action button position then add fixed class to action section
      // once scroll < action buttons then remove fixed class

      var action_buttons = $('.action-buttons');
      if (action_buttons.length) {
        var actions_buttons_position = action_buttons.position();
        //console.log(actions_buttons_position.top);
        $(window).scroll(function() {
          //console.log($(this).scrollTop())
          if ($(this).scrollTop() > actions_buttons_position.top && !action_buttons.hasClass('fixed')) {
            action_buttons.addClass('fixed');
          }
          else if ($(this).scrollTop() < actions_buttons_position.top && action_buttons.hasClass('fixed')) {
            action_buttons.removeClass('fixed');
          }
        });

      }
    }
  }

  Drupal.behaviors.modalActivate = {
    attach: function (context, settings) {
      // open modal if id is in url anchor
      var anchor = location.hash;
      if (anchor) {
        if ($(anchor).hasClass('modal')) {
          $(anchor).modal();
        }
      }
    }
  }


})(jQuery, Drupal);
